<template>
  <div class="course">
    <div class="flex f14 cl999 hour">
      <div style="min-width: 40px" class="cl000 hour-title">课时：</div>
      <div class="flex al-cn fl-war">
        <el-select v-model="form.chapter" placeholder="请选择章" class="hour-select">
          <el-option
              v-for="item in chapterList"
              :key="item"
              :label="item"
              :value="item">
          </el-option>
        </el-select>
        <i class="el-icon-arrow-right hour-icon"></i>
        <el-select v-model="form.section" placeholder="请选择节" class="hour-select">
          <el-option
              v-for="item in sectionList"
              :key="item"
              :label="item"
              :value="item">
          </el-option>
        </el-select>
        <i class="el-icon-arrow-right hour-icon"></i>
        <el-select v-model="form.smallSection" placeholder="请选择小节" class="hour-select">
          <el-option
              v-for="item in smallSectionList"
              :key="item"
              :label="item"
              :value="item">
          </el-option>
        </el-select>
        <el-button class="hour-but hour-select" type="primary">购买该课程</el-button>
      </div>
    </div>
    <div class="mb20 course-detail">
      <video
          class="videoImg"
          :src="video"
          :poster="cover"
          controls
          :loop="true"
          muted
          playsinline
          controlslist="nodownload"
      />
      <div class="white-bg borderRadius p20 cl333">
        <div class="title f15 font-bold">第一节：理论与应用理论与应用理论与应用理论与应用</div>
        <div class="time cl000 f12 pt10 pb20">课程时长： 3小时20分钟</div>
        <div class="f14 pb15 font-bold">课程章节</div>
        <div class="course-detail-list">
          <div
              class="flex ju-sp al-cn f12"
              v-for="(item,index) in courseList"
              :key="index"
              @click="name = item">
            <div class="name" :class="{cl0066FF: name === item}">{{ index + 1 }}.{{ item }}</div>
            <div class="sum">¥78</div>
          </div>
        </div>
        <div style="">
          <el-button class="mb10" style="width: 100%;" size="small" type="primary" @click="buyCourse">
            ¥48 购买该章节
          </el-button>
          <div>
            <el-button style="width: 100%;" size="small" type="info" @click="downloadCourse">下载课程</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="white-bg borderRadius p30 mb20">
      <div class="commonality-title">课程介绍</div>
<!--      <autographView/>-->
    </div>
    <!--<div ref="alipayWap" v-html="alipay"/>-->
  </div>
</template>
<script>
import AutographView from "@/components/autographView/autographView.vue";

export default {
  name: "index",
  components: {AutographView},
  data() {
    return {
      video: 'http://vjs.zencdn.net/v/oceans.mp4',
      cover: 'http://vjs.zencdn.net/v/oceans.png',
      name: '11视频名称视频名称视频名称频名称频名称频名称',
      courseList: ['11视频名称视频名称视频名称频名称频名称频名称'],
      //章节
      chapterList: [],
      //节
      sectionList: [],
      //小节
      smallSectionList: [],
      // 购买课程表单
      form: {
        chapter: '',
        section: '',
        smallSection: '',
      },
      // 弹出购买二维码
      purchaseCode: false,
      // 购买课程定时器
      timer: null,
    }
  },
  mounted() {

  },
  methods: {
    // 购买课程
    buyCourse() {
      //弹出购买二维码
      this.purchaseCode = true
      // 购买课程
      this.timer = setInterval(() => {
        this.courseBuy()
      }, 2000)
    },
    // 购买课程
    courseBuy() {
      courseBuy().then(res => {
        if (res.code === 0) {
          this.purchaseCode = false
          this.$message.success('购买成功')
          // 购买成功后的相关操作
          this.getye()
          this.close()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 获取已购买课程
    getye() {
      this.$api.get('/api/course/getye').then(res => {
        console.log(res)
      })
    },
    // 关闭购买课程
    close() {
      clearInterval(this.timer)
      this.timer = null
    },
    // 下载课程
    downloadCourse() {

    },
    // 调用支付接口
    payTwoHundred() {
      payTwoHundred({}).then((res) => {
        // 渲染支付页面
        this.alipay = res.data;
        // 防抖避免重复支付
        this.$nextTick(() => {
          // 提交支付表单
          this.$refs.alipayWap.children[0].submit();
          setTimeout(() => {
            // this.toPayFlag = false;
          }, 500);
        });
      })
    },
    // 查询是否支付成功
    queryPay() {
      // 获取地址栏
      const href = window.location.href;
      // 截取地址栏参数
      const orderId = href.split('?')[1].split('&')[1].split('=')[1];
      const param = {
        orderId: orderId,
        type: '支付宝支付'
      };
      getOrderPayType(param).then((res) => {
        if (res.code === '0000') {
          this.$message.success('支付成功');
        } else {
          this.$message.error('支付失败');
        }
      });
    },
  }
}
</script>


<style scoped lang="scss">
.course {

  &-detail {
    height: auto;
    display: block;
    margin-bottom: 15px;

    &-list {
      overflow-y: auto;
      margin-bottom: 15px;

      .name {
        width: 75%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .sum {
        padding: 3px 8px;
        background: #F3F4F6;
        border-radius: 2px 2px 2px 2px;
      }
    }
  }
}

.videoImg {
  border-radius: 6px;
  height: auto;
  width: 100%;
  aspect-ratio: 16/9;
  object-fit: cover;
}

@media screen and (min-width: 768px) {
  .hour {
    align-items: center;
    margin-bottom: 20px;

    &-icon {
      margin: 0 10px;
    }

    &-but {
      margin-left: 20px;
    }
  }
  .videoImg {
    height: 485px;
  }
  .course {
    &-detail {
      display: grid;
      grid-column-gap: 20px;
      grid-template-columns: calc(70% - 10px) calc(30% - 10px);
      margin-bottom: 20px;

      &-list {
        height: 23px;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .hour {
    &-title {
      //隐藏
      display: none;
    }

    &-icon {
      display: none;
    }

    &-select {
      width: calc(50% - 10px);
      margin-bottom: 10px;
      margin-left: 5px;
    }

    &-but {
      height: 38px;
    }
  }
  .course {
    &-list {
      height: auto;
    }
  }
}
</style>
